import _ from "lodash";
import { getAppConfig } from "config/client.config";

export const SET_PRODUCT_PARAMS = "SET_PRODUCT_PARAMS";
export const SET_ANGEL_ROUND = "SET_ANGEL_ROUND";
export const SET_SIM_PARAMS = "SET_SIM_PARAMS";
export const ADD_OVERTIME = "ADD_OVERTIME";

const _addOvertime = (status, data, err) => {
    return {
        type: ADD_OVERTIME,
        data,
        err,
        status
    };
};
const _setSimParams = (status, data, err) => {
    return {
        type: SET_SIM_PARAMS,
        data,
        err,
        status
    };
};
const _setAngelRound = (status, data, err) => {
    return {
        type: SET_ANGEL_ROUND,
        data,
        err,
        status
    };
};

const setProductParams = (ai, bi, ii, bc, unused) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Modifying Product",
                    {
                        ai: ai,
                        bi: bi,
                        ii: ii,
                        bc: bc,
                        blp: parseInt(
                            100 * (1 - stdev([ai / 100, bi / 100, ii / 100])),
                            0
                        ),
                        unused: unused
                    },
                    null
                )
            )
        );
    };
};
const finalizeProduct = () => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Fixing Product",
                    {
                        productFixed: true
                    },
                    null
                )
            )
        );
    };
};
const setLastLocation = location => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Setting Last Location",
                    {
                        lastLocation: location
                    },
                    null
                )
            )
        );
    };
};
const setAngelRound = (valuation, fundRaise, dilution) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setAngelRound(
                    "Setting Angel Data",
                    {
                        valuation: valuation,
                        fundRaise: fundRaise,
                        dilution: dilution,
                        angelFixed: true
                    },
                    null
                )
            )
        );
    };
};

const setTeamParams = (co, sa, cs, fr, cm, team) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Fixing Product",
                    {
                        co: co,
                        sa: sa,
                        cs: cs,
                        fr: fr,
                        cm: cm,
                        team: team,
                        blt: parseInt(
                            100 *
                                (1 -
                                    stdev([
                                        sa / 100,
                                        cs / 100,
                                        fr / 100,
                                        cm / 100
                                    ])),
                            0
                        )
                    },
                    null
                )
            )
        );
    };
};

const finalizeTeam = () => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Fixing Team",
                    {
                        teamFixed: true
                    },
                    null
                )
            )
        );
    };
};

const addOvertime = () => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_addOvertime("Adding Overtime", {}, null))
        );
    };
};

const endSim = () => {
    return (dispatch, getState, Request) => {
        let questions = getState().questions;
        let opsRecords = getState().opsRecords;
        let simParams = getState().simParams;

        let lastOp = _.find(opsRecords, { monthId: 24 }).data;

        // Creativity Calculations
        //==================================
        let creativeScore = 0;
        _.each(questions, question => {
            if (question.score !== undefined)
                creativeScore = creativeScore + question.score;
        });
        let creative = Math.round(creativeScore * 3.33);

        // Time Management Calculations
        //==================================
        let timeManagement = Math.round(
            100 * Math.max(0, 1 - simParams.trackers.overtimeCounter / 26)
        );

        // Balance Calculations
        //==================================
        let balanced = Math.round((simParams.blp + simParams.blt) / 2);

        // Cost Consciousness Calculations
        //==================================
        let costScore = Math.round(
            (lastOp.cashPos > 0 ? 25 : 0) +
                Math.max(
                    0,
                    25 * (1 - (_.sumBy(simParams.team, "c") - 16) / 48)
                ) +
                25 *
                    Math.min(
                        1,
                        Math.max(0, 1 - (simParams.dilution - 35) / 15)
                    ) +
                (25 * lastOp.cm) / 100
        );

        // Decision Making Calculations
        //==================================
        let decisionMaking = Math.min(
            100,
            Math.round((100 * lastOp.decisions) / 18)
        );

        // Resourceful Calculations
        //==================================
        let resourceful = Math.round(
            (lastOp.ebitda > 0
                ? 75
                : 50 * Math.max(0, 1 + lastOp.ebitda / (6 * lastOp.rev))) +
                (25 * simParams.bc) / 100
        );

        // Problem Solving Calculations
        //==================================
        let midOpData = _.find(opsRecords, {
            monthId: 12
        }).data;
        let revMult = (45 * (1 + lastOp.fr / 100)) / (1.08 ^ 5);
        let finalValuation =
            revMult * (lastOp.rev + midOpData.rev) * 6 + lastOp.cashPos;
        let problemSolving = Math.min(
            100,
            Math.max(
                0,
                Math.round(
                    (100 *
                        (finalValuation * (1 - simParams.dilution / 100) -
                            20000000)) /
                        100000000
                )
            )
        );

        // Aggregation Calculations
        //==================================
        let analytical = Math.round(
            0.6 * problemSolving + 0.4 * decisionMaking
        );
        let frugal = Math.round(0.5 * costScore + 0.5 * resourceful);
        let methodical = Math.round(0.5 * timeManagement + 0.5 * balanced);

        return Promise.resolve(
            dispatch(
                _setSimParams(
                    "Ending Sim",
                    {
                        competencyMap: {
                            timeManagement: timeManagement,
                            balanced: balanced,
                            costManagement: costScore,
                            decisionMaking: decisionMaking,
                            problemSolving: problemSolving,
                            resourceful: resourceful,

                            creative: creative,
                            analytical: analytical,
                            frugal: frugal,
                            methodical: methodical,
                            overall: Math.round(
                                0.25 * creative +
                                    0.25 * analytical +
                                    0.25 * methodical +
                                    0.25 * frugal
                            )
                        },
                        simOver: true
                    },
                    null
                )
            )
        )
            .then(() => {
                simParams = getState().simParams;
                const userId = getState().auth.user.uid;
                let data = {
                    questions: questions,
                    opsRecords: opsRecords,
                    simParams: simParams
                };
                let body = { user_id: userId, user_data: data };
                return Request.fetch(getAppConfig().endpoints.userDataPath, {
                    method: "POST",
                    body: JSON.stringify(body)
                });
            })
            .catch(err => {
                dispatch(_setSimParams("error", err, null));
                return Promise.reject(err);
            });
    };
};
class SimManagerAction {
    static setLastLocation = setLastLocation;
    static setProductParams = setProductParams;
    static setAngelRound = setAngelRound;
    static setTeamParams = setTeamParams;
    static finalizeProduct = finalizeProduct;
    static finalizeTeam = finalizeTeam;
    static endSim = endSim;
    static addOvertime = addOvertime;
}

export default SimManagerAction;

const avg = array => {
    return _.sum(array) / array.length;
};
const stdev = array => {
    return Math.sqrt(
        _.sum(_.map(array, i => Math.pow(i - avg(array), 2))) / array.length
    );
};



// WEBPACK FOOTER //
// ./src/app/simulation/redux/SimManager.action.react.js